import React, { useCallback } from "react";
import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, useGridApiContext, GridCsvExportOptions } from "@mui/x-data-grid-pro";
import { Button, createSvgIcon } from "@mui/material";
import { useTranslations } from "@fenetech/translations";
import RefreshIcon from '@mui/icons-material/Refresh';

interface iProps {
    csvOptions: any;
    resetState: () => void;
    disableRestoreGridStyle: boolean;
    disableGridExport: boolean;
}

const DownloadIcon = createSvgIcon(
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
    'SaveAlt'
);

const CustomDataGridToolbar: React.FC<iProps> = ({csvOptions, resetState, disableRestoreGridStyle, disableGridExport}) => {
    const tm = useTranslations();
    const apiRef = useGridApiContext();

    const handleExport = useCallback((options: GridCsvExportOptions) => {
        apiRef.current.exportDataAsCsv(options);
    }, [apiRef]);

    return <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        {!disableGridExport && 
            <Button startIcon={<DownloadIcon fontSize="small" />} onClick={() => handleExport(csvOptions)} variant="text" size="small" color="primary">
                {tm.Get("Download")}
            </Button>
        }
        {!disableRestoreGridStyle && 
            <Button startIcon={<RefreshIcon fontSize="small" />} onClick={resetState} variant="text" size="small" color="primary">
                {tm.Get("Reset Grid Style")}
            </Button>
        }
    </GridToolbarContainer>
};

export default CustomDataGridToolbar;